import styled from "styled-components";
import { setFontVariant, colorsPalettes } from "@similarweb/styles";
import { FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import { SWReactIcons } from "@similarweb/icons";

const { carbon } = colorsPalettes;

export const AutocompleteLabel = styled.label`
    ${setFontVariant("caption", carbon[300])};
`;

export const AutoCompleteContainer = styled(FlexColumn)`
    gap: 4px;
    width: 100%;
`;

export const TableContainer = styled(FlexColumn)`
    border: 1px solid ${carbon[50]};
    flex: 1 1 auto;
    .swReactTable-wrapper {
        height: 100px;
    }
    .swTable,
    .swReactTable-wrapper {
        display: flex;
        flex-direction: column;
        flex: 1 1 auto;
    }
    .flex-table {
        height: 100%;
    }
    .flex-table > div:first-child {
        display: flex;
        height: 100%;
        flex-direction: column;
    }
`;

export const InitialStateIcon = styled(SWReactIcons)`
    height: 90px;
    width: 150px;
    margin: 0 auto 16px;
`;

export const InitialStateIconWrapper = styled.div`
    width: 480px;
`;

export const Wrapper = styled(FlexColumn)`
    gap: 24px;
    height: 100%;
`;
